// Permite apontar para outra API no build: REACT_APP_API_URL=http://localhost:8000 npm run build
export default process.env.REACT_APP_API_URL || 'https://api.tria.health'
//export default 'https://apiwl.tria.health'
